<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="isReplace ? '变更' : esop.pkId ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="esop"
        :rules="ruleValidate"
        class="form"
        label-width="90px">
      <el-form-item v-if="esop.pkId" label="文件编号">
        <el-input v-model="esop.esopNo" disabled/>
      </el-form-item>
      <el-form-item label="操作卡状态" prop="fileType">
        <el-select v-model="esop.fileType" placeholder="请选择">
          <el-option label="受控" :value="10"/>
          <el-option label="试行" :value="20"/>
          <el-option label="样品" :value="30"/>
        </el-select>
      </el-form-item>
      <!--      <el-form-item label="文件类型" prop="category">-->
      <!--        <el-select v-model="esop.category" placeholder="请选择">-->
      <!--          <el-option label="操作卡" :value="10"/>-->
      <!--          <el-option label="图纸" :value="20"/>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
      <el-form-item label="上传文件">
        <up-load-file
            ref="upload"
            v-loading="uploadLoading"
            :show-file-list="false"
            :file="fileList"
            :auth-index="authIndex"
            @upload-success="uploadSuccess"
            @removeFile="removeFile"
            @beforeUpload="beforeUpload"/>
      </el-form-item>
      <el-form-item label="文件名称" prop="esopName">
        <el-input v-model.trim="esop.esopName" placeholder="请输入文件名称"/>
      </el-form-item>
      <el-form-item label="物料名称" prop="materialId">
        <el-input v-model.trim="esop.materialName" disabled placeholder="请选择物料">
          <template v-if="flag" slot="append">
            <el-button icon="el-icon-search" @click="$refs.materialSelect.open()"/>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="物料编号">
        <el-input v-model.trim="esop.materialNo" disabled/>
      </el-form-item>
      <material-select ref="materialSelect" @select="addMaterial"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UpLoadFile from "@/components/UploadFile.vue";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    components: {
      UpLoadFile,
      MaterialSelect,
    },

    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        uploadLoading: false,
        authIndex: this.$route.meta.authIndex,
        fileList: [],
        esop: {
          pkId: 0,
          esopNo: "",
          fileType: 10,
          category: 10,
          esopName: "",
          filePath: "",
          materialName: "",
          materialNo: "",
          materialId: "",
          detailVos: [],
        },
        flag: false,
        isReplace: false,
        ruleValidate: {
          fileType: {required: true, message: "请选择操作卡类型", trigger: "change"},
          category: {required: true, message: "请选择文件类型", trigger: "change"},
          esopName: {required: true, message: "请输入文件名称", trigger: "blur"},
          materialId: {required: true, message: "请选择物料", trigger: "change"},
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.flag = true;
        this.$nextTick(() => {
          if (row) {
            this.getData(row.pkId);
            this.flag = false;
          }
          if (mark === "replaceHandle") {
            this.isReplace = true;
          }
        });
      },

      //选择物料
      addMaterial(row) {
        this.esop.materialName = row.materialName;
        this.esop.materialId = row.materialID;
        this.esop.materialNo = row.materialNO;
      },

      // 文件上传成功
      uploadSuccess(file) {
        console.log(file);
        this.esop.filePath = file[0].key;
        this.esop.esopName = file[0].name;
        this.fileList = file;
        this.uploadLoading = false;
      },

      removeFile(fileList) {
        this.fileList = fileList;
      },
      beforeUpload() {
        this.uploadLoading = true;
        this.esop.esopName = "";
        this.esop.filePath = "";
      },
      // 获取文件信息
      getData(pkId) {
        this.contentLoading = true;
        this.$http
            .get("basic", `esops/${pkId}`)
            .then((resp) => {
              if (resp.success) {
                console.log(resp);
                this.esop = Object.assign(this.esop, resp.data);
                if (!this.isReplace) {
                  this.fileList = [{name: resp.data.esopName, key: resp.data.filePath}];
                }
              }
              this.contentLoading = false;
            })
            .catch(() => {
              this.contentLoading = false;
            });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.fileList.length === 0) {
              this.$confirm("请上传文件", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            if (!this.isReplace) {
              this.$http
                  .save("basic", "esops", this.esop)
                  .then((resp) => {
                    this.submitLoading = false;
                    if (resp.success) {
                      if (this.esop.pkId) {
                        this.$emit("save-success");
                        this.$message.success("编辑成功");
                      } else {
                        this.$emit("save-success");
                        this.$message.success("添加成功");
                      }
                      this.dialogVisible = false;
                    }
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
            } else {
              const params = {
                pkid: this.esop.pkId,
                esopName: this.esop.esopName,
                filePath: this.esop.filePath,
              };
              this.$http
                  .post("basic", "esops/replaceEsop", params)
                  .then((res) => {
                    if (res.success) {
                      this.$emit("save-success");
                      this.$message.success("替换成功");
                      this.dialogVisible = false;
                    }
                    this.submitLoading = false;
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
            }
          }
        });
      },
    },
  };
</script>
<style scoped>
.el-input-group__append button.el-button {
  background-color: skyblue;
  color: white;
}
</style>